import type { AvailabilityInfo } from "~/domains/product/api/pna/AvailabilityInfo";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import type { PackagingInformationEntry, WarehouseStockData } from "~/domains/product/types/ProductData";
import { toMapFn } from "~/common/utils/reducers";

export function constructAvailability(product: ProductDescriptor): ProductDescriptor {
  const salesByCode = product.base.salesCampaign;
  const fifteenDigitByCode = product.base.fifteenDigit;

  if (
    !fifteenDigitByCode ||
    Object.keys(fifteenDigitByCode).length === 0 ||
    !salesByCode ||
    Object.keys(salesByCode).length === 0
  ) {
    return product;
  }

  const packagingInformation: PackagingInformationEntry[] = Object.keys(fifteenDigitByCode).map((packCode) => {
    const salesData = salesByCode[packCode] ?? [];
    const fifteenDigitEntry = fifteenDigitByCode[packCode];
    const existingPackaging = product.availability?.packagingInformation.find(
      (packaging) => packaging.packCode === packCode,
    );

    return {
      ...existingPackaging,
      packCode,
      packSize: fifteenDigitEntry.packSize,
      minOrderQuantity: existingPackaging?.minOrderQuantity ?? 1,
      totalWarehouse: existingPackaging?.totalWarehouse ?? EMPTY_WAREHOUSE,
      global: existingPackaging?.global ?? EMPTY_WAREHOUSE,
      warehouses: existingPackaging?.warehouses ?? [],
      preferredPackQuantity: existingPackaging?.preferredPackQuantity ?? null,
      primaryWarehouseCode: existingPackaging?.primaryWarehouseCode ?? "",
      primaryWarehouseName: existingPackaging?.primaryWarehouseName ?? "",
      replenishmentLeadTimeDate: existingPackaging?.replenishmentLeadTimeDate ?? null,
      salesStock: toMapFn(
        salesData,
        (sale) => sale.code,
        (sale) => sale.quantity,
      ),
    };
  });
  const availability: AvailabilityInfo = {
    code: product.base.code,
    hasPackaging: true,
    isFreshPnaCall: false,
    sapMaterialNumber: product.base.sapMaterialNumber,
    packagingInformation,
  };

  return {
    ...product,
    availability,
    isLoaded: product.prices.length > 0,
    isLoading: product.isPriceLoading,
  };
}

const EMPTY_WAREHOUSE: WarehouseStockData = {
  code: "",
  name: "",
  inClarification: 0,
  inProduction: [],
  inStock: [],
  inStockWeekly: [],
  inProductionWeekly: [],
};
